<template>
  <div
    v-show="visibleNoticeBanner && showAside"
    :class="b()"
  >
    <span
      :class="b('container')"
    >
      <template v-if="!$slots.default">
        <em
          class="zkicon icontishi1"
        />
        <span
          v-overflow-tooltip
          :class="[b('desc'), 'text-ellipsis']"
        >
          {{ notifyMsg }}
        </span>
        <span
          v-if="isUpgradeShow"
          class="handleBtn"
          @click="handleOperate"
        >
          {{ $t('rightsMana.upgradeBtn') }}
        </span>
      </template>
      <template v-else>
        <slot></slot>
      </template>
      <em
        class="zkicon iconguanbi"
        @click="handleClose"
      />
    </span>
  </div>
</template>

<script>
import theme from '@zk/theme/lib/variables.scss';
import { mapGetters } from 'vuex';
import { closeBanner } from '@/api/message';
import * as permission from 'common-module/src/config/permission';

export default {
  name: 'SubscriptionBanner',
  bemNS: theme.bemNS,
  props: {
    bannerVOS: {
      type: Object,
      default: null
    },
    showAside: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      visibleNoticeBanner: false,
      notifyMsg: '',
      bannerId: ''
    };
  },
  computed: {
    ...mapGetters('user', ['messageBannerNoticeList', 'userProductRights', 'checkAccessPermission']),
    hasUpgradePermission() {
      return this.checkAccessPermission(permission.upgrade);
    },
    isFree() {
      return this.userProductRights?.productSchemeVO?.schemeType === 0 || this.userProductRights?.productSchemeVO?.schemeType === 1;
    },
    isUpgradeShow() {
      if (this.$store.getters.isAWSUserMark) {
        return false;
      }
      return !this.isPrivateVersion && this.hasUpgradePermission;
    }
  },
  watch: {
    bannerVOS: {
      immediate: true,
      handler(value) {
        if (value) {
          this.initNotify(value);
        }
      }
    }
  },
  created() {
  },
  mounted() {
    this.checkMessageBanner();
    this.eventBus.$on('global:successPaymentState', this.handleCloseNoticeBanner);
  },
  beforeDestroy() {
    this.eventBus.$off('global:successPaymentState', this.handleCloseNoticeBanner);
  },
  methods: {
    handleCloseNoticeBanner(value) {
      if (value) {
        this.visibleNoticeBanner = false;
      }
    },
    initNotify(data) {
      if (data.status === 0) {
        this.bannerId = data.id;
        this.visibleNoticeBanner = true;
        this.notifyMsg = data.bannerInfo;
        return;
      }

      if (data.status > 0 && this.bannerId === data.id && this.visibleNoticeBanner) {
        this.visibleNoticeBanner = false;
      }

    },
    checkMessageBanner() {
      const data = this.messageBannerNoticeList[0];
      if (data && data.status === 0) {
        this.bannerId = data.id;
        this.notifyMsg = data.bannerInfo;
        this.visibleNoticeBanner = true;
      }
    },
    async handleClose() {
      await closeBanner({ id: this.bannerId });
      this.bannerId = null;
      this.visibleNoticeBanner = false;
    },
    handleOperate() {
      /* eslint-disable */
                       
      const params = {};
              
                                                                  
                      
                
             
        
                                                                       
               
      /* eslint-disable */
      this.eventBus.$emit('global:openUpgradeDialog', params);
    }
  }
};
</script>

<style lang="scss">
@include b(subscription-banner) {
  width: 100%;
  overflow: hidden;
  height: 50px;
  line-height: 50px;
  z-index: 1000;
  @include e(container) {
    background-color: var(--state-danger-bg);
    height: 100%;
    width: 100%;
  }
  .zkicon {
    font-size: 15px;
  }
  .el-link {
    margin-left: 24px;
  }
  .icontishi1 {
    color: var(--danger-color);
  }
  .iconguanbi {
    margin-left: 83px;
    cursor: pointer;
  }
  @include e(container) {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  @include e(desc) {
    margin-left: 4px;
    font-weight: var(--weight-font-Semiblod);
    margin-right: 20px;
    max-width: 80%;
    color: #CC3C39;
  }

  @include e(light-text) {
    color: var(--primary-color);
  }
  .handleBtn {
    color: var(--primary-color);
    cursor: pointer;
    float: right;
    >em {
      color: var(--primary-color);
    }
  }
}
</style>
